/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useEffect } from "react";
import Config from "data/config";
import { Logger } from "cms/utils/log/logger";

const DebugJSON = (props) => {

    let { json, name } = props;
    const enabled = Config.Debug.useDebug;
    const [content, setContent] = useState(json);
    const [open, setOpen] = useState(false);
    const [currentStyle, setCurrentStyle] = useState("json_debug_hidden");

    useEffect(() => {
        setContent(json);
    }, [json]);

    const toggleView = function () {
        Logger.debug(`toggleView ${open}`);
        // Logger.flush()
        if (open) {
            setCurrentStyle("json_debug_hidden");
        } else {
            setCurrentStyle("json_debug_visible");
        }
        setOpen(!open);
    };

    if (!enabled) {
        return null;
    } else {
        return (
            <div className='json_debug_container'>
                <div className='json_debug_highlight'
                    onClick={toggleView}
                >
                    JSON DEBUG - {name}
                </div>
                <pre className={currentStyle}>
                    {content && JSON.stringify(content, null, 2)}
                </pre>
            </div>
        );
    }
};

export default DebugJSON;
